const HOME_URL = '/'

const BREAKPOINTS = {
    TABLET: 768,
    DESKTOP: 1024
}

export {
    HOME_URL,
    BREAKPOINTS
}
